class Radios extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.current_value = this.querySelector(".radios--option-current")),
      (this.inputs = this.querySelectorAll("input")),
      (this.is_swatches = "true" === this.getAttribute("data-is-swatches")),
      this.preventFormSubmitOnEnter(),
      this.is_swatches &&
        (theme.utils.setSwatchColors(this.inputs), this.current_value) &&
        this.updateLabelOnChange();
  }
  disconnectedCallback() {
    this.inputs.off("keydown.Radios change.Radios");
  }
  preventFormSubmitOnEnter() {
    this.inputs.on("keydown.Radios", (t) => {
      "Enter" === t.key && t.preventDefault();
    });
  }
  updateLabelOnChange() {
    this.inputs.on("change.Radios", (t) => {
      this.current_value.textContent = t.target.value;
    });
  }
}
customElements.define("radios-root", Radios);

document.addEventListener("DOMContentLoaded", () => {
  // Select all product root containers
  const productRoots = document.querySelectorAll(
    ".product--root[data-custom-id='custom-product--root']"
  );

  productRoots.forEach((productRoot) => {
    // Add event listener to each product root
    productRoot.addEventListener("click", (event) => {
      // Check if the clicked element is a swatch button
      const swatch = event.target.closest(".radios--swatch-button");

      if (swatch) {
        const imgSrc = swatch.dataset.variantImage;
        const imageRoot = productRoot.querySelector(".image--root");
        const imageElement = imageRoot.querySelector("img");

        if (imageElement) {
          // Preload the new image to reduce visual delay
          const preloadedImage = new Image();
          preloadedImage.src = imgSrc;

          // Once the image is preloaded, update the image src
          preloadedImage.onload = () => {
            imageElement.srcset = imgSrc;
          };
        }
      }
    });
  });
});
